import React, {PropsWithChildren} from 'react';
import 'stylesheets/components/shared-separator.scss';

const Separator = ({children}: Required<PropsWithChildren>) => (
  <div className="shared-separator">
    <span className="shared-separator-text">{children}</span>
    <hr className="shared-separator-line" aria-hidden="true" />
  </div>
);

export default Separator;
